import type {AxiosError} from 'axios';
import {useMutation, useQueryClient, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {
	updateSnils,
	type UpdateSnilsErrorResponse,
	type UpdateSnilsRequest,
	type UpdateSnilsResponse,
} from '../../http';

export function useUpdateSnils(
	options?: UseMutationOptions<UpdateSnilsResponse, AxiosError<UpdateSnilsErrorResponse>, UpdateSnilsRequest>,
): UseMutationResult<UpdateSnilsResponse, AxiosError<UpdateSnilsErrorResponse>, UpdateSnilsRequest> {
	const queryClient = useQueryClient();

	return useMutation<UpdateSnilsResponse, AxiosError<UpdateSnilsErrorResponse>, UpdateSnilsRequest>(
		(request) => updateSnils(request).then(({data}) => data),
		{
			...options,
			onSuccess: (data, variables, context) => {
				queryClient.invalidateQueries({queryKey: ['identification', 'info']});
				options?.onSuccess?.(data, variables, context);
			},
		},
	);
}
